import { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';
import { calculerDureeCreneauMinutes, formatHeuresMinutes } from '../utils/formatDuree';

function ModalPlanning({ operateur, onClose }) {
  const [planning, setPlanning] = useState([]);
  const [showAddSlot, setShowAddSlot] = useState(false);
  const [newSlot, setNewSlot] = useState({
    jour_semaine: 0,
    heure_debut: '09:00',
    heure_fin: '17:00'
  });

  const joursSemaine = [
    { id: 0, label: 'Lundi' },
    { id: 1, label: 'Mardi' },
    { id: 2, label: 'Mercredi' },
    { id: 3, label: 'Jeudi' },
    { id: 4, label: 'Vendredi' },
    { id: 5, label: 'Samedi' },
    { id: 6, label: 'Dimanche' }
  ];

  useEffect(() => {
    loadPlanning();
  }, []);

  const loadPlanning = async () => {
    const { data, error } = await supabase
      .from('planning_operateurs')
      .select('*')
      .eq('operateur_id', operateur.id)
      .order('jour_semaine', { ascending: true })
      .order('heure_debut', { ascending: true });

    if (error) {
      console.error('Erreur chargement planning:', error);
    } else {
      setPlanning(data || []);
    }
  };

  const handleAddSlot = async (e) => {
    e.preventDefault();
    
    const { error } = await supabase
      .from('planning_operateurs')
      .insert([{
        operateur_id: operateur.id,
        jour_semaine: newSlot.jour_semaine,
        heure_debut: newSlot.heure_debut,
        heure_fin: newSlot.heure_fin
      }]);

    if (error) {
      console.error('Erreur ajout créneau:', error);
      alert('Erreur : ' + error.message);
    } else {
      loadPlanning();
      setShowAddSlot(false);
      setNewSlot({
        jour_semaine: 0,
        heure_debut: '09:00',
        heure_fin: '17:00'
      });
    }
  };

  const handleDeleteSlot = async (id) => {
    if (window.confirm('Supprimer ce créneau ?')) {
      const { error } = await supabase
        .from('planning_operateurs')
        .delete()
        .eq('id', id);

      if (error) {
        console.error('Erreur suppression:', error);
      } else {
        loadPlanning();
      }
    }
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 2000
    }}>
      <div style={{
        backgroundColor: '#ffffff',
        borderRadius: '20px',
        width: '800px',
        maxWidth: '95%',
        maxHeight: '90vh',
        overflow: 'hidden',
        border: '2px solid #1aabf9',
        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
        display: 'flex',
        flexDirection: 'column'
      }}>
        {/* Header */}
        <div style={{
          padding: '30px 40px',
          borderBottom: '2px solid #e0e5ea',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <div>
            <h2 style={{ 
              color: '#212529',
              margin: 0,
              marginBottom: '5px',
              fontSize: '24px',
              fontWeight: '600'
            }}>
              📅 Planning - {operateur.prenom} {operateur.nom}
            </h2>
            <div style={{ color: '#6c757d', fontSize: '14px' }}>
              Définir les disponibilités hebdomadaires
            </div>
          </div>
          <button
            onClick={onClose}
            style={{
              padding: '10px 20px',
              backgroundColor: 'transparent',
              color: '#6c757d',
              border: '1px solid #dee2e6',
              borderRadius: '8px',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: '600'
            }}
          >
            Fermer
          </button>
        </div>

        {/* Content */}
        <div style={{
          padding: '40px',
          overflowY: 'auto',
          flex: 1
        }}>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '25px'
          }}>
            <h3 style={{
              color: '#212529',
              fontSize: '18px',
              fontWeight: '600',
              margin: 0
            }}>
              Disponibilités hebdomadaires
            </h3>
            <button
              onClick={() => setShowAddSlot(true)}
              style={{
                padding: '10px 20px',
                backgroundColor: '#1aabf9',
                color: '#ffffff',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
                fontSize: '14px',
                fontWeight: '600'
              }}
            >
              + Ajouter un créneau
            </button>
          </div>

          {/* Affichage du planning par jour */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
            {joursSemaine.map(jour => {
              const creneaux = planning.filter(p => p.jour_semaine === jour.id);
              return (
                <div
                  key={jour.id}
                  style={{
                    backgroundColor: creneaux.length > 0 ? '#e3f2fd' : '#f8f9fa',
                    padding: '20px',
                    borderRadius: '10px',
                    border: creneaux.length > 0 ? '2px solid #1aabf9' : '1px solid #dee2e6'
                  }}
                >
                  <div style={{
                    fontWeight: '600',
                    color: '#212529',
                    marginBottom: creneaux.length > 0 ? '12px' : '0',
                    fontSize: '15px'
                  }}>
                    {jour.label}
                  </div>
                  {creneaux.length === 0 ? (
                    <div style={{ color: '#6c757d', fontSize: '13px', fontStyle: 'italic' }}>
                      Aucun créneau défini
                    </div>
                  ) : (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                      {creneaux.map(creneau => (
                        <div
                          key={creneau.id}
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            backgroundColor: '#ffffff',
                            padding: '12px 16px',
                            borderRadius: '8px'
                          }}
                        >
                          <span style={{ color: '#212529', fontSize: '14px', fontWeight: '500' }}>
                            🕐 {creneau.heure_debut.substring(0, 5)} - {creneau.heure_fin.substring(0, 5)}
                          </span>
                          <button
                            onClick={() => handleDeleteSlot(creneau.id)}
                            style={{
                              padding: '6px 12px',
                              backgroundColor: 'transparent',
                              color: '#dc3545',
                              border: '1px solid #dc3545',
                              borderRadius: '6px',
                              cursor: 'pointer',
                              fontSize: '12px',
                              fontWeight: '600'
                            }}
                          >
                            Supprimer
                          </button>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              );
            })}
          </div>

          {/* Résumé des heures hebdomadaires */}
          {planning.length > 0 && (() => {
            const heuresParJour = joursSemaine.map(jour => {
              const creneaux = planning.filter(p => p.jour_semaine === jour.id);
              const minutesJour = creneaux.reduce((sum, c) => {
                return sum + calculerDureeCreneauMinutes(c.heure_debut.substring(0, 5), c.heure_fin.substring(0, 5));
              }, 0);
              return { ...jour, minutes: minutesJour };
            }).filter(j => j.minutes > 0);

            const totalMinutes = heuresParJour.reduce((sum, j) => sum + j.minutes, 0);

            return (
              <div style={{
                marginTop: '25px',
                padding: '20px',
                backgroundColor: '#e8f5e9',
                borderRadius: '10px',
                border: '2px solid #4caf50'
              }}>
                <h4 style={{
                  color: '#2e7d32',
                  fontSize: '16px',
                  fontWeight: '600',
                  marginTop: 0,
                  marginBottom: '15px'
                }}>
                  ⏱️ Récapitulatif hebdomadaire
                </h4>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', marginBottom: '15px' }}>
                  {heuresParJour.map(jour => (
                    <div key={jour.id} style={{
                      backgroundColor: '#ffffff',
                      padding: '8px 14px',
                      borderRadius: '8px',
                      fontSize: '13px',
                      color: '#212529',
                      border: '1px solid #c8e6c9'
                    }}>
                      <strong>{jour.label}</strong> : {formatHeuresMinutes(jour.minutes)}
                    </div>
                  ))}
                </div>
                <div style={{
                  backgroundColor: '#ffffff',
                  padding: '15px 20px',
                  borderRadius: '8px',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  border: '2px solid #4caf50'
                }}>
                  <span style={{ fontSize: '15px', fontWeight: '600', color: '#212529' }}>
                    Total hebdomadaire
                  </span>
                  <span style={{ fontSize: '22px', fontWeight: '700', color: '#2e7d32' }}>
                    {formatHeuresMinutes(totalMinutes)}
                  </span>
                </div>
              </div>
            );
          })()}

          {/* Formulaire d'ajout de créneau */}
          {showAddSlot && (
            <div style={{
              marginTop: '25px',
              padding: '25px',
              backgroundColor: '#f8f9fa',
              borderRadius: '10px',
              border: '2px solid #1aabf9'
            }}>
              <h4 style={{
                color: '#212529',
                fontSize: '16px',
                fontWeight: '600',
                marginTop: 0,
                marginBottom: '20px'
              }}>
                Nouveau créneau
              </h4>
              <form onSubmit={handleAddSlot}>
                <div style={{ marginBottom: '15px' }}>
                  <label style={{
                    display: 'block',
                    color: '#495057',
                    marginBottom: '8px',
                    fontSize: '14px',
                    fontWeight: '600'
                  }}>
                    Jour
                  </label>
                  <select
                    value={newSlot.jour_semaine}
                    onChange={(e) => setNewSlot({...newSlot, jour_semaine: parseInt(e.target.value)})}
                    style={{
                      width: '94%',
                      padding: '10px 14px',
                      backgroundColor: '#ffffff',
                      color: '#212529',
                      border: '1px solid #dee2e6',
                      borderRadius: '8px',
                      fontSize: '14px',
                      cursor: 'pointer'
                    }}
                  >
                    {joursSemaine.map(jour => (
                      <option key={jour.id} value={jour.id}>{jour.label}</option>
                    ))}
                  </select>
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', marginBottom: '20px' }}>
                  <div>
                    <label style={{
                      display: 'block',
                      color: '#495057',
                      marginBottom: '8px',
                      fontSize: '14px',
                      fontWeight: '600'
                    }}>
                      Heure de début
                    </label>
                    <input
                      type="time"
                      value={newSlot.heure_debut}
                      onChange={(e) => setNewSlot({...newSlot, heure_debut: e.target.value})}
                      required
                      style={{
                        width: '80%',
                        padding: '10px 14px',
                        backgroundColor: '#ffffff',
                        color: '#212529',
                        border: '1px solid #dee2e6',
                        borderRadius: '8px',
                        fontSize: '14px'
                      }}
                    />
                  </div>
                  <div>
                    <label style={{
                      display: 'block',
                      color: '#495057',
                      marginBottom: '8px',
                      fontSize: '14px',
                      fontWeight: '600'
                    }}>
                      Heure de fin
                    </label>
                    <input
                      type="time"
                      value={newSlot.heure_fin}
                      onChange={(e) => setNewSlot({...newSlot, heure_fin: e.target.value})}
                      required
                      style={{
                        width: '80%',
                        padding: '10px 14px',
                        backgroundColor: '#ffffff',
                        color: '#212529',
                        border: '1px solid #dee2e6',
                        borderRadius: '8px',
                        fontSize: '14px'
                      }}
                    />
                  </div>
                </div>
                <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                  <button
                    type="button"
                    onClick={() => setShowAddSlot(false)}
                    style={{
                      padding: '10px 20px',
                      backgroundColor: 'transparent',
                      color: '#6c757d',
                      border: '1px solid #dee2e6',
                      borderRadius: '8px',
                      cursor: 'pointer',
                      fontSize: '14px',
                      fontWeight: '600'
                    }}
                  >
                    Annuler
                  </button>
                  <button
                    type="submit"
                    style={{
                      padding: '10px 20px',
                      backgroundColor: '#1aabf9',
                      color: '#ffffff',
                      border: 'none',
                      borderRadius: '8px',
                      cursor: 'pointer',
                      fontSize: '14px',
                      fontWeight: '600'
                    }}
                  >
                    Ajouter
                  </button>
                </div>
              </form>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default ModalPlanning;